export const projectList = [
    { id: "LB", name: 'Bachaquero Tierra', projectId: "e8de6828-b7db-11ef-bebc-22937bb103f9" },
    { id: "LS", name: 'Lagunillas Tierra', projectId: "e6c51ece-b7db-11ef-bebc-22937bb103f9" }
]

export const projectListFaja = [
    { id: "Junin Sur", name: 'Junin Sur', projectId: "9e0a8d2f-0a32-11f0-8f30-00505652cca1" },
    { id: "Cedeño", name: 'Cedeño', projectId: "a8e7ac5a-0a32-11f0-8f30-00505652cca1" }
]